import { Controller } from "@hotwired/stimulus"

// ARIA combobox pattern for eligible staff dropdown
// Keyboard: ↑/↓ navigate, Enter select, Escape close
export default class extends Controller {
  static targets = ["search", "list", "option"]

  connect() {
    this.selectedIndex = -1
    this.visibleOptions = []
    this.updateVisibleOptions()
  }

  handleKeydown(event) {
    switch (event.key) {
      case "ArrowDown":
        event.preventDefault()
        this.moveSelection(1)
        break
      case "ArrowUp":
        event.preventDefault()
        this.moveSelection(-1)
        break
      case "Enter":
        event.preventDefault()
        this.selectCurrent()
        break
      case "Escape":
        event.preventDefault()
        this.close()
        break
      case "Tab":
        this.close()
        break
    }
  }

  filterStaff() {
    const query = this.searchTarget.value.toLowerCase()

    this.optionTargets.forEach(option => {
      const name = option.dataset.staffName || ""
      const match = name.includes(query)
      option.style.display = match ? "" : "none"
    })

    this.selectedIndex = -1
    this.updateVisibleOptions()
    this.highlightOption()
  }

  moveSelection(delta) {
    if (this.visibleOptions.length === 0) return

    this.selectedIndex += delta

    if (this.selectedIndex < 0) {
      this.selectedIndex = this.visibleOptions.length - 1
    } else if (this.selectedIndex >= this.visibleOptions.length) {
      this.selectedIndex = 0
    }

    this.highlightOption()
  }

  selectCurrent() {
    if (this.selectedIndex >= 0 && this.selectedIndex < this.visibleOptions.length) {
      this.visibleOptions[this.selectedIndex].click()
    }
  }

  highlightOption() {
    this.visibleOptions.forEach((option, index) => {
      if (index === this.selectedIndex) {
        option.classList.add("bg-[var(--pu-magenta-light)]")
        option.scrollIntoView({ block: "nearest" })
      } else {
        option.classList.remove("bg-[var(--pu-magenta-light)]")
      }
    })
  }

  updateVisibleOptions() {
    this.visibleOptions = this.optionTargets.filter(
      option => option.style.display !== "none"
    )
  }

  closeOnOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  close() {
    this.element.remove()
  }
}
